import './trick-component.scss';
import { CardComponent } from '../card-component/card-component';
import { CardId, SeatPosition, Speed, Trick } from '../../app/types';
import { SeatPosFor } from '../../app-interfaces/game-engine-helper';
import { cardStartDomRegistry } from '../../utils/domRegistry';
import { claimTrickAnimationSpeed, playCardAnimationSpeed } from '../../app/defaults';
import { classNames, cssVars } from '../../utils/mixed';
import { environment } from '../../env';
import { useAppSelector } from '../../app/hooks';
import React, { CSSProperties } from 'react';

type TrickComponentProps = {
    trick: Trick;
    show: boolean;
};

export const TrickComponent: React.FC<TrickComponentProps> = ({ trick: { cardIds, winner }, show }) => {
    const {
        settings: { speedCardAnimations },
        sharkSettings: { playCardAnimations, claimTrickAnimations },
    } = useAppSelector((state) => state.app);
    const fallBackPlayCardAnimationSpeed = playCardAnimationSpeed[Speed.medium];
    const playCardAnimationDuration =
        ((environment === 'audrey' && playCardAnimationSpeed[speedCardAnimations]) ||
            (environment === 'shark' && playCardAnimationSpeed[playCardAnimations])) ??
        fallBackPlayCardAnimationSpeed;
    const fallBackClaimTrickAnimationSpeed = claimTrickAnimationSpeed[Speed.medium];
    const claimTrickAnimationDuration =
        claimTrickAnimationSpeed[claimTrickAnimations] ?? fallBackClaimTrickAnimationSpeed;

    const style: CSSProperties = cssVars({
        '--playCardAnimationDuration': `${playCardAnimationDuration}ms`,
        '--claimTrickAnimationDuration': `${claimTrickAnimationDuration}ms`,
    });
    return (
        <section
            className={classNames('TrickComponent', winner && 'claimed', show && 'show', `winner-${winner}`)}
            style={style}
        >
            {cardIds.map((cardId) => (
                <TrickLane cardId={cardId} key={cardId} />
            ))}
        </section>
    );
};

const TrickLane: React.FC<{ cardId: CardId }> = ({ cardId }) => {
    const cards = useAppSelector((state) => state.cards);
    const card = cards[cardId];
   // const { table } = useAppSelector((state) => state);
    const { seatData } = useAppSelector((state) => state.table);
    const seatPosition = SeatPosFor(card.bridgePosition, seatData[SeatPosition.bottom]);
    const DOMRectangle = cardStartDomRegistry[cardId];

    const windowX = window.innerWidth / 2;
    const windowY = window.innerHeight / 2;


    let posX = DOMRectangle ? `${DOMRectangle.x}px` :
                 seatPosition === SeatPosition.right ? `${window.innerWidth}px` :
                 seatPosition === SeatPosition.top ||  seatPosition === SeatPosition.bottom ? `${windowX}px` :  '1px';

    let posY = DOMRectangle ? `${DOMRectangle.y}px` :
                 seatPosition === SeatPosition.right ||  seatPosition === SeatPosition.left ? `${windowY}px` :
                 seatPosition === SeatPosition.bottom ? `${window.innerHeight}px` : '1px';

    if (posX === '0px' && posY === '0px') {
         posX = seatPosition === SeatPosition.right ? `${window.innerWidth}px` :
                seatPosition === SeatPosition.top ||  seatPosition === SeatPosition.bottom ? `${windowX}px` :  '1px';

         posY = seatPosition === SeatPosition.right ||  seatPosition === SeatPosition.left ? `${windowY}px` :
                seatPosition === SeatPosition.bottom ? `${window.innerHeight}px` : '1px';
    }

    const style = cssVars({
        '--startPosVisibleX': `${posX} `,
        '--startPosVisibleY': `${posY}`
    });


    return (
        <section
            className={classNames('TrickLane', seatPosition)}
            style={style}
        >
            <CardComponent card={card} hand={{ isInteractive: false, isVisible: true }} />
        </section>
    );
};
